import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    staticClass: "search-card",
    attrs: {
      "size": "small",
      "title": "筛选"
    }
  }, [_c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('a-row', {
    staticClass: "fold"
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "日期范围",
      "prop": "time"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.form.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "维修状态",
      "prop": "repairsStatus"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择维修状态"
    },
    model: {
      value: _vm.form.repairsStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "repairsStatus", $$v);
      },
      expression: "form.repairsStatus"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-select-option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("草稿")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("待受理")]), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("待接单")]), _c('a-select-option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("不受理")]), _c('a-select-option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("维修中")]), _c('a-select-option', {
    attrs: {
      "value": 7
    }
  }, [_vm._v("已完成")]), _c('a-select-option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("已评价")]), _c('a-select-option', {
    attrs: {
      "value": 9
    }
  }, [_vm._v("补录")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "保修单号/故障描述",
      "prop": "queryStr"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入保修单号/故障描述"
    },
    model: {
      value: _vm.form.queryStr,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "queryStr", $$v);
      },
      expression: "form.queryStr"
    }
  })], 1)], 1)], 1), _c('a-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.expand,
      expression: "expand"
    }],
    staticClass: "fold"
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "维修类型",
      "prop": "type"
    }
  }, [_c('a-radio-group', {
    attrs: {
      "button-style": "solid"
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_c('a-radio-button', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" 全部 ")]), _c('a-radio-button', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" 校内人员维修 ")]), _c('a-radio-button', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" 校外人员维修 ")])], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "html-type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.form.resetFields();
      }
    }
  }, [_vm._v("重置")]), _c('a', {
    style: {
      marginLeft: '5px',
      fontSize: '12px'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(" " + _vm._s(_vm.expand ? '收起' : '展开') + " "), _c('a-icon', {
    attrs: {
      "type": _vm.expand ? 'up' : 'down'
    }
  })], 1)], 1)], 1)], 1), _c('a-card', {
    attrs: {
      "size": "small",
      "title": "报修单列表",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "templateTable",
    attrs: {
      "dataSource": _vm.tableData,
      "columns": _vm.columns,
      "pagination": _vm.paginationTable,
      "bordered": "",
      "rowKey": "number",
      "scroll": {
        y: 500
      },
      "size": "middle",
      "loading": _vm.loading
    },
    on: {
      "change": _vm.change
    },
    scopedSlots: _vm._u([{
      key: "drafterTemp",
      fn: function fn(text, row) {
        return [_c('div', {
          staticClass: "text-ellipsis"
        }, [_vm._v(_vm._s(row.organName) + " / " + _vm._s(row.postName))])];
      }
    }, {
      key: "repairsStatus",
      fn: function fn(repairsStatus, row) {
        return [0 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("草　稿")]) : _vm._e(), 1 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待受理")]) : _vm._e(), 2 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待受理")]) : _vm._e(), 3 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待接单")]) : _vm._e(), 4 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("不受理")]) : _vm._e(), 5 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("维修中")]) : _vm._e(), 6 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("已评价")]) : _vm._e(), 7 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("已完成")]) : _vm._e(), 8 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("外部维修")]) : _vm._e(), 9 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("补　录")]) : _vm._e()];
      }
    }, {
      key: "operation",
      fn: function fn(text, record) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', {
          key: "1"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewRigister(record.id);
            }
          }
        }, [_vm._v(" 查看 ")])], 1), record.repairsStatus <= 2 || record.repairsStatus == 5 || record.repairsStatus == 3 ? _c('a-menu-item', {
          key: "2"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.disposeClick(record);
            }
          }
        }, [_vm._v("处理")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  }, [_c('template', {
    slot: "title"
  }, [_c('div', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.collectionShow
    }
  }, [_vm._v("补录")])], 1)])], 2)], 1), _c('a-modal', {
    attrs: {
      "visible": _vm.previewShow,
      "footer": null,
      "centered": true,
      "width": "80rem"
    },
    on: {
      "cancel": _vm.handleCancel
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(70vh)"
    },
    attrs: {
      "src": _vm.previewSrc,
      "seamless": ""
    }
  })]), _c('a-modal', {
    staticClass: "bulu",
    attrs: {
      "title": "报修补录",
      "visible": _vm.collection,
      "centered": true,
      "dialog-style": {
        top: '20px'
      },
      "maskClosable": false,
      "width": "55%"
    },
    on: {
      "ok": _vm.collectionSubmit,
      "cancel": _vm.collectionCancel
    }
  }, [_c('a-form-model', {
    ref: "collectionform",
    attrs: {
      "model": _vm.collectionform,
      "rules": _vm.collectionformRules
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "报修人",
      "prop": "selectPersonName",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "click": function click($event) {
        return _vm.personClick($event);
      }
    },
    model: {
      value: _vm.collectionform.selectPersonName,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "selectPersonName", $$v);
      },
      expression: "collectionform.selectPersonName"
    }
  }), _c('select-person', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "personPick",
    staticClass: "disabled-content",
    attrs: {
      "businessId": 1,
      "width": "100%",
      "height": "9.375rem",
      "tabList": _vm.tabList,
      "isRadio": 1
    },
    on: {
      "input": _vm.childrenInput
    },
    model: {
      value: _vm.form.mainDelivery,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mainDelivery", $$v);
      },
      expression: "form.mainDelivery"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "联系电话",
      "prop": "phone",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "联系电话"
    },
    model: {
      value: _vm.collectionform.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "phone", $$v);
      },
      expression: "collectionform.phone"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "设备名称",
      "prop": "itemName",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "设备名称"
    },
    model: {
      value: _vm.collectionform.itemName,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "itemName", $$v);
      },
      expression: "collectionform.itemName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "设备型号",
      "prop": "itemModel",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "设备型号"
    },
    model: {
      value: _vm.collectionform.itemModel,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "itemModel", $$v);
      },
      expression: "collectionform.itemModel"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "设备编号",
      "prop": "itemNum",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "设备编号"
    },
    model: {
      value: _vm.collectionform.itemNum,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "itemNum", $$v);
      },
      expression: "collectionform.itemNum"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "设备位置",
      "prop": "location",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "设备位置"
    },
    model: {
      value: _vm.collectionform.location,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "location", $$v);
      },
      expression: "collectionform.location"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "故障时间",
      "prop": "reDate",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-date-picker', {
    attrs: {
      "value-format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.collectionform.reDate,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "reDate", $$v);
      },
      expression: "collectionform.reDate"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "故障描述",
      "prop": "description",
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 20
      }
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "故障描述",
      "auto-size": {
        minRows: 3,
        maxRows: 5
      },
      "maxLength": 300
    },
    model: {
      value: _vm.collectionform.description,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "description", $$v);
      },
      expression: "collectionform.description"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "维修类别",
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 20
      },
      "prop": "status"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.collectionform.status,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "status", $$v);
      },
      expression: "collectionform.status"
    }
  }, [_c('a-row', [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("现场维修")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("厂家维修")])], 1)], 1)], 1)], 1)], 1), _vm.collectionform.status == 0 ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "维修人",
      "prop": "comUserId",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择维修人员"
    },
    model: {
      value: _vm.collectionform.comUserId,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "comUserId", $$v);
      },
      expression: "collectionform.comUserId"
    }
  }, _vm._l(_vm.repairPersonList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(" " + _vm._s(item.userName) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "维修时间",
      "prop": "repairDate",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-date-picker', {
    attrs: {
      "value-format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.collectionform.repairDate,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "repairDate", $$v);
      },
      expression: "collectionform.repairDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.collectionform.status == 0 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "更换零件清单",
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 20
      },
      "prop": "supplies"
    }
  }, [_c('table', {
    staticClass: "single-table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "16%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 名称 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 型号 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 单位 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 数量 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 单价 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 总价 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 厂家 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" 损坏原因 ")])]), _vm._l(_vm.collectionform.supplies, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.collectionform.supplies[index].partName,
        callback: function callback($$v) {
          _vm.$set(_vm.collectionform.supplies[index], "partName", $$v);
        },
        expression: "collectionform.supplies[index].partName"
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.collectionform.supplies[index].partModel,
        callback: function callback($$v) {
          _vm.$set(_vm.collectionform.supplies[index], "partModel", $$v);
        },
        expression: "collectionform.supplies[index].partModel"
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.collectionform.supplies[index].partUnit,
        callback: function callback($$v) {
          _vm.$set(_vm.collectionform.supplies[index], "partUnit", $$v);
        },
        expression: "collectionform.supplies[index].partUnit"
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 0
      },
      on: {
        "change": function change($event) {
          return _vm.partNumberChange(index);
        }
      },
      model: {
        value: _vm.collectionform.supplies[index].partNumber,
        callback: function callback($$v) {
          _vm.$set(_vm.collectionform.supplies[index], "partNumber", $$v);
        },
        expression: "collectionform.supplies[index].partNumber"
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      on: {
        "change": function change($event) {
          return _vm.partPriceChange(index);
        }
      },
      model: {
        value: _vm.collectionform.supplies[index].partPrice,
        callback: function callback($$v) {
          _vm.$set(_vm.collectionform.supplies[index], "partPrice", $$v);
        },
        expression: "collectionform.supplies[index].partPrice"
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2,
        "disabled": ""
      },
      model: {
        value: _vm.collectionform.supplies[index].totalPrice,
        callback: function callback($$v) {
          _vm.$set(_vm.collectionform.supplies[index], "totalPrice", $$v);
        },
        expression: "collectionform.supplies[index].totalPrice"
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 0
      },
      model: {
        value: _vm.collectionform.supplies[index].partFactory,
        callback: function callback($$v) {
          _vm.$set(_vm.collectionform.supplies[index], "partFactory", $$v);
        },
        expression: "collectionform.supplies[index].partFactory"
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "2"
      }
    }, [_c('a-textarea', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 1,
        "auto-size": {
          maxRows: 2
        },
        "maxLength": 300
      },
      model: {
        value: _vm.collectionform.supplies[index].damageReason,
        callback: function callback($$v) {
          _vm.$set(_vm.collectionform.supplies[index], "damageReason", $$v);
        },
        expression: "\n                                                collectionform.supplies[index].damageReason\n                                            "
      }
    })], 1), _c('a-popconfirm', {
      attrs: {
        "title": "确认删除该条记录？",
        "ok-text": "确认",
        "placement": "topLeft",
        "cancel-text": "取消"
      },
      on: {
        "confirm": function confirm($event) {
          return _vm.delMatter(item);
        }
      }
    }, [_c('a-icon', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "slot": "icon",
        "type": "question-circle-o"
      },
      slot: "icon"
    }), index >= 0 && _vm.formObject.detail.matterList.length !== index + 1 ? _c('a-icon', {
      staticClass: "oper-icon",
      attrs: {
        "type": "minus-circle",
        "title": "删除"
      }
    }) : _vm._e()], 1), _vm.formObject.detail.matterList.length === index + 1 ? _c('a-icon', {
      staticClass: "oper-icon",
      attrs: {
        "type": "plus-circle",
        "title": "添加"
      },
      on: {
        "click": _vm.addMatter
      }
    }) : _vm._e()], 1);
  })], 2)])])], 1)], 1) : _vm._e(), _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "反馈内容",
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 20
      },
      "prop": "remark"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入反馈内容！",
      "auto-size": {
        minRows: 3
      },
      "maxLength": 300
    },
    model: {
      value: _vm.collectionform.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "remark", $$v);
      },
      expression: "collectionform.remark"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 20
      },
      "prop": "fixPerson"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "accept": ".jpg,.jpge,.png",
      "default-file-list": _vm.collectionform.fileList,
      "customRequest": _vm.actionUpload,
      "before-upload": _vm.beforeUpload,
      "remove": _vm.delFile,
      "file-list": _vm.collectionform.fileList
    },
    model: {
      value: _vm.collectionform.fileList,
      callback: function callback($$v) {
        _vm.$set(_vm.collectionform, "fileList", $$v);
      },
      expression: "collectionform.fileList"
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "printTable"
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(70vh)"
    },
    attrs: {
      "src": _vm.printSrc,
      "seamless": "",
      "id": "printFrame"
    }
  })]), _vm.loadingPrint ? _c('div', {
    staticClass: "print-spin"
  }, [_c('a-spin', {
    attrs: {
      "tip": "打印生成中..."
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };